/**
 * Fire-and-forget for a promise whose failure is already shown elsewhere
 * (a query's error state with Try again, or a toast). Settling it here keeps
 * the rejection out of the console and Sentry as "unhandled".
 *
 * Accepts what Apollo returns: a promise, `false` (a lazy load() after its
 * first call) or undefined.
 */
export function settle(result: unknown): void {
  if (result && typeof (result as Promise<unknown>).catch === 'function') {
    (result as Promise<unknown>).catch(() => undefined);
  }
}
